"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleModelSelect = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const backendImport_1 = require("@front/backendImport");
const client_1 = require("@rws-framework/client");
const models_types_1 = require("../../types/models.types");
const voices_helper_1 = require("@front/helpers/voices.helper");
const SignalService_1 = __importStar(require("@front/services/SignalService"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="simple-model-selector dropdown-side-${x => x.dropdownSide}${x => x.rounded ? ' rounded' : ''}">
    <div class="dropdown${x => x.isDropdownOpen ? ' show' : ''}${x => x.inForm === 'true' ? ' in-form' : ''}">
        ${(0, fast_element_1.when)(x => x.selectedAvatar, (0, fast_element_1.html) `<img src="${x => { var _a; return ((_a = x.selectedAvatar) === null || _a === void 0 ? void 0 : _a.logo) ? ('/uploads/' + x.selectedAvatar.logo.filename).thumb('square-mini') : '/assets/images/avatar.jpg'; }}" alt="${x => { var _a; return (_a = x.selectedAvatar) === null || _a === void 0 ? void 0 : _a.name; }}" class="avatar-image me-2">`)}
        <button 
            type="button" 
            class="btn btn-light dropdown-toggle model-selector-button" 
            @click="${(x, c) => x.toggleDropdown(c.event)}"
            aria-haspopup="true" 
            aria-expanded="${x => x.isDropdownOpen}">
            <span class="selection-text">
                ${(0, fast_element_1.when)(x => x.selectedAvatar, (0, fast_element_1.html) `<i class="iconsminds-male mr-1"></i>`, (0, fast_element_1.html) `<i class="iconsminds-gear mr-1"></i>`)}                
                ${x => x.currentSelection}
            </span>            
        </button>
        ${(0, fast_element_1.when)(x => x.selectedAvatar && x.selectedAvatar.onboardingAvatar, (0, fast_element_1.html) `
            <span class="badge badge-warning ms-2">${x => x.selectedAvatar.onboardingAvatar.profession.name}</span>
        `)}
        
        <div class="dropdown-menu${x => x.isDropdownOpen ? ' show' : ''}" @click="${(x, c) => c.event.stopPropagation()}">
            
            <div class="dropdown-control-bar">
                <small class="text-muted mb-2 d-block">${'modelSelect.instruction'.t()}</small>
                <div class="search-container">
                    <input 
                        type="text" 
                        class="form-control form-control-sm search-input" 
                        placeholder="Search providers, models and avatars..."
                        value="${x => x.searchQuery}"
                        @input="${(x, c) => x.handleSearch(c.event)}"
                        @keyup="${(x, c) => x.handleSearchKeyup(c.event)}">
                    <i class="iconsminds-magnifi-glass search-icon"></i>
                </div>
                <div class="filter-buttons">
                    <button 
                        type="button" 
                        class="btn btn-outline-primary btn-sm filter-btn ${x => x.showModels ? 'active' : ''}"
                        @click="${(x, c) => x.toggleModelsFilter(c.event)}">
                        <i class="iconsminds-gear me-1"></i>
                        ${'modelSelect.models'.t()}
                    </button>                    
                    <button 
                        ?hidden="${x => x.noAvatar === 'true'}"
                        type="button" 
                        class="btn btn-outline-success btn-sm filter-btn ${x => x.showAvatars ? 'active' : ''}"
                        @click="${(x, c) => x.toggleAvatarsFilter(c.event)}">
                        <i class="iconsminds-male me-1"></i>
                        ${'modelSelect.avatars'.t()}
                    </button>
                    
                </div>
            </div>
            
            
            <div class="dropdown-content">
                ${(0, fast_element_1.repeat)(x => x.filteredDropdownItems, (0, fast_element_1.html) `
                    ${(0, fast_element_1.when)(x => x.isHeader, (0, fast_element_1.html) `
                        <div class="dropdown-header">
                            <strong>${x => x.label}</strong>
                        </div>
                    `)}
                    ${(0, fast_element_1.when)(x => !x.isHeader, (0, fast_element_1.html) `
                        <button 
                            type="button" 
                            class="dropdown-item ${x => x.type === 'avatar' ? 'avatar-item' : 'model-item'}" 
                            @click="${(x, c) => c.parent.selectItem(x)}">
                            ${(0, fast_element_1.when)(x => x.type === 'avatar', (0, fast_element_1.html) `
                                <div class="avatar-option">
                                    <img src="${x => { var _a; return ((_a = x.avatar) === null || _a === void 0 ? void 0 : _a.logo) ? ('/uploads/' + x.avatar.logo.filename).thumb('square-mini') : '/assets/images/avatar.jpg'; }}" alt="${x => { var _a; return (_a = x.avatar) === null || _a === void 0 ? void 0 : _a.name; }}" class="avatar-image me-2">
                                    <div class="avatar-info">
                                        <span class="avatar-name">${x => x.label} <span class="avatar-info-help">
                                            <rws-tooltip side="bottom" text="${x => { var _a; return (_a = x.avatar) === null || _a === void 0 ? void 0 : _a.description; }}"><i class="simple-icon-question"></i></rws-tooltip>
                                        </span></span> 
                                        ${(0, fast_element_1.when)(x => x.avatar.onboardingAvatar, (0, fast_element_1.html) `
                                            <small class="avatar-profession">${x => x.avatar.onboardingAvatar.profession.name}</small>
                                        `)}
                                        <div class="avatar-badges">
                                            ${(0, fast_element_1.when)(x => { var _a; return (_a = x.avatar.creator) === null || _a === void 0 ? void 0 : _a.name; }, (0, fast_element_1.html) `<span class="badge badge-info">${x => x.avatar.creator.name}</span>`)}
                                        </div>
                                    </div>
                                    <span class="badge badge-warning">${(x, c) => c.parent.projectedCost(x)}</span>
                                </div>
                            `)}
                            ${(0, fast_element_1.when)(x => x.type === 'model', (0, fast_element_1.html) `
                                <span class="model-option">
                                    <span>${x => x.label}</span>
                                    <span class="badge badge-warning">${(x, c) => c.parent.projectedCost(x)}</span>
                                </span>
                            `)}
                        </button>
                    `)}
                `)}
            </div>
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host(.dropdown-open) {
  z-index: 101 !important;
}

.simple-model-selector .avatar-image {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}
.simple-model-selector .dropdown {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}
.simple-model-selector .dropdown.in-form {
  display: block;
}
.simple-model-selector .dropdown .model-selector-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 250px;
  background: white;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  padding: 0.5rem 1rem;
  text-align: left;
}
.simple-model-selector .dropdown .model-selector-button:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.simple-model-selector .dropdown .model-selector-button .selection-text {
  display: flex;
  align-items: center;
  flex: 1;
}
.simple-model-selector .dropdown .dropdown-menu {
  position: absolute;
  top: 0;
  left: -0;
  transform: translateY(-105%);
  min-width: 350px;
  max-height: 400px;
  overflow: hidden;
  border-radius: 0.375rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.15);
  margin: 2px 0 0;
  padding: 0;
  z-index: 1000;
  display: none;
}
.simple-model-selector .dropdown .dropdown-menu.show {
  display: block;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-control-bar {
  position: sticky;
  top: 0;
  z-index: 1001;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  padding: 0.75rem;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-control-bar .search-container {
  position: relative;
  margin-bottom: 0.5rem;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-control-bar .search-container .search-input {
  padding-right: 2.5rem;
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-control-bar .search-container .search-input:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-control-bar .search-container .search-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  pointer-events: none;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-control-bar .filter-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-control-bar .filter-buttons .filter-btn {
  font-size: 0.8rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.2s;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-control-bar .filter-buttons .filter-btn.active {
  background-color: var(--primary-color);
  color: white;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-control-bar .filter-buttons .filter-btn.btn-outline-success.active {
  background-color: var(--success-color, #28a745);
  border-color: var(--success-color, #28a745);
  color: white;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-control-bar .filter-buttons .filter-btn:hover {
  transform: translateY(-1px);
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-content {
  max-height: 300px;
  overflow-y: auto;
  padding: 0.5rem 0 2.5rem 0;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-header {
  padding: 0.75rem 1rem 0.5rem;
  color: #6c757d;
  font-size: 0.875rem;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 0.5rem;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-header strong {
  color: #495057;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-item {
  padding: 0.75rem 1rem;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  color: #212529;
  text-decoration: none;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-item:hover {
  background-color: #f8f9fa;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-item:focus {
  background-color: #e3f2fd;
  outline: none;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-item .avatar-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-item .avatar-option .avatar-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-item .avatar-option .avatar-info .avatar-name {
  font-weight: 500;
  color: #212529;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-item .avatar-option .avatar-info .avatar-profession {
  color: #6c757d;
  font-style: italic;
  line-height: 1.2;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-item .avatar-option .avatar-info .avatar-badges {
  display: flex;
  gap: 0.25rem;
  flex-wrap: wrap;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-item .avatar-option .avatar-info .avatar-badges .badge {
  font-size: 0.75rem;
  padding: 0.125rem 0.375rem;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-item .model-option {
  font-size: 0.9rem;
  color: #495057;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-item.avatar-item {
  border-left: 3px solid #28a745;
  padding-left: 0.75rem;
}
.simple-model-selector .dropdown .dropdown-menu .dropdown-item.model-item {
  border-left: 3px solid var(--primary-color);
  padding-left: 0.75rem;
}
.simple-model-selector.dropdown-side-bottom .dropdown .dropdown-menu {
  top: auto;
  left: -0;
  bottom: 0;
  transform: none;
  transform: translateY(105%);
}
.simple-model-selector.rounded .dropdown .model-selector-button {
  border: solid 1px var(--primary-color);
  border-radius: 25px;
  padding: 3px 25px 3px 15px;
  height: 38px;
}
.simple-model-selector.rounded .dropdown button .selection-text {
  font-weight: 500;
  color: var(--primary-color);
}
.simple-model-selector.rounded .dropdown button::after {
  color: var(--primary-color);
}
.simple-model-selector.rounded .avatar-image {
  width: 38px;
  height: 38px;
}`;
const shadowOptions = { "mode": "open" };
let SimpleModelSelect = class SimpleModelSelect extends client_1.RWSViewComponent {
    constructor(signalService) {
        super();
        this.signalService = signalService;
        this.modelsChoices = [];
        this.avatars = [];
        this.providers = new Map();
        this.dropdownItems = [];
        this.filteredDropdownItems = [];
        this.isDropdownOpen = false;
        this.currentSelection = 'Choose AI Model or Avatar';
        // Search and filter properties
        this.searchQuery = '';
        this.showModels = true;
        this.showAvatars = true;
        this.showLiveChats = false;
        // Flag to prevent list reload during avatar selection
        this.isSelectingAvatar = false;
        this.training = 'false';
        this.inForm = 'false';
        this.noAvatar = 'false';
        this.showAvatarProfession = false;
        this.rounded = false;
        this.dropdownSide = 'top';
    }
    getElevenLabsModels() {
        return voices_helper_1.liveChats;
    }
    async connectedCallback() {
        super.connectedCallback();
        // Initialize avatar reload signal
        this.avatarReloadSignal = this.signalService.getSignal('avatar_reload', { initialValue: false });
        // Listen for avatar reload signals
        this.avatarReloadSignal.value$.subscribe(shouldReload => {
            if (shouldReload) {
                console.log('🔄 SimpleModelSelect: Avatar reload signal received, reloading avatars');
                this.reloadAvatars();
                // Reset signal
                this.avatarReloadSignal.setValue(false);
            }
        });
        if (!this.aiProvider) {
            this.aiProvider = 'openrouter';
        }
        // Initialize current selection
        if (!this.currentSelection) {
            this.currentSelection = this.getPlaceholderText();
        }
        await this.initList();
        // Add click outside listener to close dropdown
        document.addEventListener('click', this.handleClickOutside.bind(this));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('click', this.handleClickOutside.bind(this));
    }
    handleClickOutside(event) {
        const target = event.target;
        const host = this.getShadowRoot().host;
        if (!host.contains(target) && this.isDropdownOpen) {
            this.closeDropdown(true);
        }
    }
    async initList() {
        if (this.training === 'true') {
            this.aiProvider = 'together';
            for (const prov of backendImport_1.trainingProviders) {
                for (const model of prov.models) {
                    this.addProvider(prov.name, prov.value, model);
                }
            }
            this.buildDropdownItems();
            return;
        }
        if (!this.aiProvider) {
            return;
        }
        // Load models from OpenRouter/Together
        this.modelsChoices = (await this.apiService.back.get('ai.model-list', { routeParams: { provider: this.aiProvider } })).data;
        this.sortProviders();
        // Load avatars if not disabled
        if (this.noAvatar !== 'true') {
            this.avatars = (await this.apiService.back.get('avatar.list', { queryParams: { widget: '1' } })).data.filter(a => a.model && a.model.model && a.model.model.value);
        }
        // Process value after all data is loaded
        this.processValue();
        // Build dropdown items after processing value
        this.buildDropdownItems();
    }
    mainProviderChanged(oldVal, newValue) {
        if (newValue && !this.isSelectingAvatar) {
            this.aiProvider = newValue;
            this.initList();
        }
    }
    valueChanged(oldVal, newValue) {
        if (newValue !== oldVal) {
            // Re-process value when it changes and data is loaded
            this.processValue();
        }
    }
    processValue() {
        var _a;
        // Reset selections
        this.selectedModel = null;
        this.selectedProvider = null;
        this.selectedAvatar = null;
        // If no value is provided, show placeholder
        if (!this.value || this.value === '') {
            this.currentSelection = this.getPlaceholderText();
            return;
        }
        // Check avatars first
        if (this.avatars.length > 0) {
            const avatar = this.avatars.find(a => a.id === Number(this.value));
            if (avatar) {
                this.selectedAvatar = avatar;
                this.selectedModel = avatar.model.model;
                this.selectedProvider = avatar.model.provider;
                this.currentSelection = avatar.name;
                return;
            }
        }
        // Check models
        for (const provider of this.providers.values()) {
            for (const model of provider.models) {
                if (model.value === this.value) {
                    this.selectedProvider = provider;
                    this.selectedModel = provider.models.find(item => item.value === this.value);
                    this.currentSelection = `${provider.name}: ${(_a = this.selectedModel) === null || _a === void 0 ? void 0 : _a.label}`;
                    return;
                }
            }
        }
        // If value doesn't match any known model/avatar, show placeholder
        this.currentSelection = this.getPlaceholderText();
    }
    getPlaceholderText() {
        return 'Choose AI Model or Avatar';
    }
    buildDropdownItems() {
        var _a, _b;
        this.dropdownItems = [];
        // Add avatars section first if enabled and available
        if (this.noAvatar !== 'true' && this.avatars.length > 0) {
            this.dropdownItems.push({
                id: 'avatars-header',
                label: 'Avatars',
                type: 'avatar',
                isHeader: true
            });
            for (const avatar of this.avatars) {
                const elevenLabsModels = this.getElevenLabsModels();
                const isTalking = avatar.isVoiceAgent && !avatar.processing && ((_b = (_a = avatar.model) === null || _a === void 0 ? void 0 : _a.model) === null || _b === void 0 ? void 0 : _b.value) ?
                    (0, voices_helper_1.isModelInElevenLabs)(avatar.model.model.value) : false;
                this.dropdownItems.push({
                    id: avatar.id,
                    label: avatar.name,
                    model: avatar.model.model,
                    type: 'avatar',
                    avatar,
                    isTalking
                });
            }
        }
        // Add provider sections
        for (const provider of this.providers.values()) {
            // Add provider header
            this.dropdownItems.push({
                id: `provider-${provider.value}`,
                label: provider.name,
                type: 'provider',
                provider,
                isHeader: true
            });
            // Add models for this provider
            for (const model of provider.models) {
                const isTalking = (0, voices_helper_1.isModelInElevenLabs)(model.value);
                this.dropdownItems.push({
                    id: model.value,
                    label: model.label,
                    type: 'model',
                    model,
                    provider,
                    isTalking
                });
            }
        }
        this.applyFilters();
    }
    applyFilters() {
        let filtered = this.dropdownItems;
        // Apply type filters - include items based on what is enabled
        filtered = this.dropdownItems.filter(item => {
            // Always include items if both filters are enabled
            if (this.showModels && this.showAvatars)
                return true;
            // If only models are enabled
            if (this.showModels && !this.showAvatars) {
                if (item.type === 'model' || item.type === 'provider')
                    return true;
                if (item.isHeader && item.label !== 'Avatars')
                    return true;
                return false;
            }
            // If only avatars are enabled  
            if (!this.showModels && this.showAvatars) {
                if (item.type === 'avatar')
                    return true;
                if (item.isHeader && item.label === 'Avatars')
                    return true;
                return false;
            }
            // If both are disabled, show nothing
            if (!this.showModels && !this.showAvatars) {
                return false;
            }
            return false;
        });
        // Apply ElevenLabs models filter when showLiveChats is enabled
        if (this.showLiveChats) {
            const elevenLabsModels = this.getElevenLabsModels();
            filtered = filtered.filter(item => {
                if (item.isHeader) {
                    // For headers, check if they have any matching model children
                    const hasMatchingChildren = filtered.some(child => !child.isHeader &&
                        child.type === 'model' &&
                        child.model &&
                        (0, voices_helper_1.isModelInElevenLabs)(child.model.value) &&
                        this.isChildOfHeader(child, item));
                    return hasMatchingChildren;
                }
                else if (item.type === 'model' && item.model) {
                    return (0, voices_helper_1.isModelInElevenLabs)(item.model.value);
                }
                else if (item.type === 'avatar') {
                    // Include avatars if they use ElevenLabs compatible models
                    return item.avatar ? (0, voices_helper_1.isAvatarTalking)(item.avatar) : false;
                }
                return false;
            });
        }
        // Apply search filter
        if (this.searchQuery && this.searchQuery.trim()) {
            const query = this.searchQuery.toLowerCase().trim();
            const searchFiltered = [];
            for (const item of filtered) {
                if (item.isHeader) {
                    // Check if header itself matches the search (for provider names)
                    const headerMatches = item.label.toLowerCase().includes(query);
                    // Check if this header should be included based on children or header match
                    const hasMatchingChildren = filtered.some(child => !child.isHeader &&
                        (child.label.toLowerCase().includes(query) ||
                            (child.provider && child.provider.name.toLowerCase().includes(query))) &&
                        this.isChildOfHeader(child, item));
                    if (headerMatches || hasMatchingChildren) {
                        searchFiltered.push(item);
                    }
                }
                else {
                    // Search in item label, provider name, and model description
                    const itemMatches = item.label.toLowerCase().includes(query) ||
                        (item.provider && item.provider.name.toLowerCase().includes(query)) ||
                        (item.model && item.model.description && item.model.description.toLowerCase().includes(query)) ||
                        (item.avatar && item.avatar.name.toLowerCase().includes(query));
                    if (itemMatches) {
                        searchFiltered.push(item);
                    }
                }
            }
            filtered = searchFiltered;
        }
        this.filteredDropdownItems = filtered;
    }
    isChildOfHeader(child, header) {
        var _a, _b;
        if (header.label === 'Avatars' && child.type === 'avatar')
            return true;
        if (header.type === 'provider' && child.type === 'model' && ((_a = child.provider) === null || _a === void 0 ? void 0 : _a.value) === ((_b = header.provider) === null || _b === void 0 ? void 0 : _b.value))
            return true;
        return false;
    }
    handleSearch(event) {
        const input = event.target;
        this.searchQuery = input.value;
        this.applyFilters();
    }
    handleSearchKeyup(event) {
        // Additional keyup handling if needed
        this.applyFilters();
    }
    toggleModelsFilter(event) {
        event.preventDefault();
        event.stopPropagation();
        this.showModels = !this.showModels;
        this.applyFilters();
    }
    toggleAvatarsFilter(event) {
        event.preventDefault();
        event.stopPropagation();
        this.showAvatars = !this.showAvatars;
        this.applyFilters();
    }
    toggleLiveChatFilter(event) {
        event.preventDefault();
        event.stopPropagation();
        this.showLiveChats = !this.showLiveChats;
        this.applyFilters();
    }
    toggleDropdown(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.isDropdownOpen = !this.isDropdownOpen;
        if (this.isDropdownOpen) {
            this.getShadowRoot().host.classList.add('dropdown-open');
        }
        else {
            this.getShadowRoot().host.classList.remove('dropdown-open');
        }
    }
    closeDropdown(resetFilters = true) {
        this.isDropdownOpen = false;
        this.getShadowRoot().host.classList.remove('dropdown-open');
        // Only clear search and reset filters when explicitly requested
        if (resetFilters) {
            this.searchQuery = '';
            this.applyFilters();
        }
    }
    selectItem(item) {
        if (item.isHeader)
            return;
        // Close dropdown but don't reset filters/search when selecting items
        this.closeDropdown(false);
        if (item.type === 'avatar' && item.avatar) {
            this.isSelectingAvatar = true;
            this.selectedAvatar = item.avatar;
            this.selectedModel = item.avatar.model.model;
            this.selectedProvider = item.avatar.model.provider;
            this.currentSelection = item.avatar.name;
            this.onChange({
                provider: this.selectedProvider,
                model: this.selectedModel,
                aiProvider: 'inthub',
                avatar: item.avatar.id,
                avatarProvider: item.avatar.model.aiProvider,
                canTalk: item.isTalking || false
            });
            // Reset flag after a short delay to allow parent to process the change
            setTimeout(() => {
                this.isSelectingAvatar = false;
            }, 100);
        }
        else if (item.type === 'model' && item.model && item.provider) {
            this.selectedModel = item.model;
            this.selectedProvider = item.provider;
            this.selectedAvatar = null;
            this.currentSelection = `${item.provider.name}: ${item.model.label}`;
            this.onChange({
                provider: this.selectedProvider,
                model: this.selectedModel,
                aiProvider: 'openrouter',
                canTalk: item.isTalking || false
            });
        }
    }
    sortProviders() {
        this.providers = new Map();
        for (const item of this.modelsChoices) {
            const providerName = item.label.split(':')[0];
            const providerVal = item.value.split('/')[0];
            this.addProvider(providerName, providerVal, item);
        }
        this.buildDropdownItems();
    }
    addProvider(providerName, providerVal, model) {
        var _a, _b;
        const modelName = model.label.split(':').pop().trim();
        if (!this.providers.has(providerVal)) {
            this.providers.set(providerVal, {
                name: providerName,
                value: providerVal,
                models: [
                    {
                        label: modelName,
                        value: model.value,
                        description: model.description,
                        cost: (_a = model.cost) !== null && _a !== void 0 ? _a : 0
                    }
                ]
            });
        }
        else {
            if (this.providers.get(providerVal).models.find(m => m.value === model.value)) {
                return;
            }
            this.providers.get(providerVal).models.push({ label: modelName, value: model.value, description: model.description, cost: (_b = model.cost) !== null && _b !== void 0 ? _b : 0 });
        }
    }
    onChange(selected) {
        const ev = new CustomEvent('model:selected', {
            detail: selected,
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(ev);
    }
    projectedCost(item) {
        var _a;
        let model;
        if (item.type === 'avatar') {
            model = item.avatar.model.model;
        }
        else {
            model = item.model;
        }
        const avgTokens = 4000;
        const costPerToken = (_a = Number(model === null || model === void 0 ? void 0 : model.cost)) !== null && _a !== void 0 ? _a : 0;
        const avgCost = costPerToken * (avgTokens);
        return '~ $' + avgCost.toFixed(3);
    }
    /**
     * Reload avatars list (triggered by signal after new avatar creation)
     */
    async reloadAvatars() {
        console.log('🔄 SimpleModelSelect[' + this.name + ']: Reloading avatars...');
        if (this.noAvatar === 'true') {
            console.log('🚫 SimpleModelSelect[' + this.name + ']: Avatar loading disabled, skipping reload');
            return;
        }
        try {
            // Reload avatars list using the same method as in initList
            this.avatars = (await this.apiService.back.get('avatar.list', { queryParams: { widget: '1' } })).data.filter(a => a.model && a.model.model && a.model.model.value);
            // Check if there's a newly selected avatar in localStorage that should be applied
            const selectedAvatarId = localStorage.getItem('ai.selectedAvatar');
            if (selectedAvatarId && selectedAvatarId !== 'null' && selectedAvatarId !== 'undefined') {
                console.log('🎭 SimpleModelSelect[' + this.name + ']: Setting value to newly created avatar:', selectedAvatarId);
                // Update the component's value
                this.value = selectedAvatarId;
                // Find the new avatar in the loaded list
                const newAvatar = this.avatars.find(a => a.id.toString() === selectedAvatarId);
                if (newAvatar) {
                    // Create the selected model object
                    const selectedModel = {
                        aiProvider: 'inthub',
                        provider: newAvatar.model.provider,
                        model: newAvatar.model.model,
                        avatar: selectedAvatarId,
                        avatarProvider: 'inthub',
                        canTalk: newAvatar.isVoiceAgent || false
                    };
                    console.log('🎭 SimpleModelSelect[' + this.name + ']: Triggering selection change for new avatar:', selectedModel);
                    // Trigger the selection change to save to storage and update signals
                    this.onChange(selectedModel);
                }
                else {
                    console.warn('⚠️ SimpleModelSelect[' + this.name + ']: New avatar not found in loaded list:', selectedAvatarId);
                }
            }
            // Rebuild dropdown items with new avatars
            this.buildDropdownItems();
            // Apply current filters
            this.applyFilters();
            // Reprocess current value to ensure proper selection (now includes the updated value)
            this.processValue();
            console.log('✅ SimpleModelSelect: Avatars reloaded successfully');
        }
        catch (error) {
            console.error('❌ SimpleModelSelect: Failed to reload avatars:', error);
        }
    }
    /**
     * Static method to trigger avatar reload across all simple-model-select instances
     */
    static triggerAvatarReload(signalService) {
        console.log('📡 SimpleModelSelect: Triggering global avatar reload signal');
        const avatarReloadSignal = signalService.getSignal('avatar_reload', { initialValue: false });
        avatarReloadSignal.setValue(true);
    }
};
exports.SimpleModelSelect = SimpleModelSelect;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SimpleModelSelect.prototype, "avatars", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SimpleModelSelect.prototype, "dropdownItems", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SimpleModelSelect.prototype, "filteredDropdownItems", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.IProvider !== "undefined" && backendImport_1.IProvider) === "function" ? _b : Object)
], SimpleModelSelect.prototype, "selectedProvider", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.IProvidedModel !== "undefined" && backendImport_1.IProvidedModel) === "function" ? _c : Object)
], SimpleModelSelect.prototype, "selectedModel", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof backendImport_1.IAvatar !== "undefined" && backendImport_1.IAvatar) === "function" ? _d : Object)
], SimpleModelSelect.prototype, "selectedAvatar", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SimpleModelSelect.prototype, "isDropdownOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SimpleModelSelect.prototype, "currentSelection", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SimpleModelSelect.prototype, "searchQuery", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SimpleModelSelect.prototype, "showModels", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SimpleModelSelect.prototype, "showAvatars", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SimpleModelSelect.prototype, "showLiveChats", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", typeof (_e = typeof models_types_1.AIProviderFrontType !== "undefined" && models_types_1.AIProviderFrontType) === "function" ? _e : Object)
], SimpleModelSelect.prototype, "mainProvider", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_f = typeof models_types_1.AIProviderFrontType !== "undefined" && models_types_1.AIProviderFrontType) === "function" ? _f : Object)
], SimpleModelSelect.prototype, "aiProvider", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Object)
], SimpleModelSelect.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SimpleModelSelect.prototype, "training", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SimpleModelSelect.prototype, "inForm", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SimpleModelSelect.prototype, "noAvatar", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], SimpleModelSelect.prototype, "showAvatarProfession", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], SimpleModelSelect.prototype, "rounded", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SimpleModelSelect.prototype, "dropdownSide", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SimpleModelSelect.prototype, "name", void 0);
exports.SimpleModelSelect = SimpleModelSelect = __decorate([
    (0, client_1.RWSView)('simple-model-select', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(SignalService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof SignalService_1.SignalServiceInstance !== "undefined" && SignalService_1.SignalServiceInstance) === "function" ? _a : Object])
], SimpleModelSelect);
SimpleModelSelect.defineComponent();
